import React from "react";
import { TextField, Box, Card } from "@material-ui/core";
import { styles } from "../../styles/styles";
import { useForm } from "react-hook-form";
import axios from "axios";
import Notify from "src/notification/Notify";
import ButtonV3 from "src/components/ButtonV3";

export default function CisAddPatientAllergies({ patient }) {
  const patientId = patient.id;
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const onSubmit = (data) => {
    let formData = new FormData();
    formData.append("patient_id", patientId);
    formData.append("date", data?.date || "");
    formData.append("description", data?.description || "");

    axios
      .post(`/v1/patient-allergies/store`, formData)
      .then((response) => {
        Notify.successRequest("Allergies");
      })
      .catch((err) => console.log(err));
  };

  return (
    <div className="flex w-full flex-col">
      <form>
        <div className="mx-auto" style={styles.parentContainerAdd}>
          <Card elevation={3} className="p-4" component={Box}>
            <div style={styles.divContainerColumn}>
              <div style={styles.divContainer}>
                <TextField
                  label={
                    <label style={styles.label}>
                      Date<span style={styles.astirisColor}>*</span>
                    </label>
                  }
                  variant="outlined"
                  fullWidth
                  type="date"
                  InputLabelProps={{
                    shrink: true,
                  }}
                  {...register("date", { required: true })}
                  error={errors.date}
                  helperText={errors.date && "Date is required"}
                />
              </div>
              <div style={styles.divContainer}>
                <TextField
                  label={<label style={styles.label}>Description</label>}
                  variant="outlined"
                  fullWidth
                  {...register("description")}
                />
              </div>
            </div>
          </Card>
        </div>

        <div className="mx-auto" style={styles.button}>
          <ButtonV3 onClick={handleSubmit(onSubmit)}>Save</ButtonV3>
        </div>
      </form>
    </div>
  );
}
